import type { ActiveTabKeys } from '@/components/Provider/BlocksProvider';

export enum EventType {
  ACTIVE_TAB_CHANGE = 'ACTIVE_TAB_CHANGE',
  PREVIEW_OPEN = 'PREVIEW_OPEN',
}

export class EventManager {
  private static handlers: Record<EventType, Array<(...args: any[]) => any>> = {
    [EventType.ACTIVE_TAB_CHANGE]: [],
    [EventType.PREVIEW_OPEN]: [],
  } as any;

  public static on(type: EventType.ACTIVE_TAB_CHANGE, callback: (payload: { currentTab: ActiveTabKeys, nextTab: ActiveTabKeys; }) => boolean): void;
  public static on(type: EventType.PREVIEW_OPEN, callback: () => boolean): void;
  public static on(type: EventType, handler: (...args: any[]) => any) {
    this.handlers[type] = this.handlers[type] || [];
    this.handlers[type].push(handler);
  }

  public static off(type: EventType, handler: (...args: any[]) => any) {
    const list = this.handlers[type] || [];
    const index = list.indexOf(handler);
    if (index > -1) list.splice(index, 1);
  }

  public static exec(type: EventType.ACTIVE_TAB_CHANGE, payload: { currentTab: ActiveTabKeys, nextTab: ActiveTabKeys; }): boolean;
  public static exec(type: EventType.PREVIEW_OPEN): boolean;
  public static exec(type: EventType, ...args: any[]): boolean {
    const list = this.handlers[type] || [];
    let result = true;
    list.forEach(fn => {
      try {
        const r = fn(...args);
        if (r === false) result = false;
      } catch {
        // ignore
      }
    });
    return result;
  }
}
